// extracted by mini-css-extract-plugin
export default {"delkab-promotion__image":"DelkabPromotionWidget_delkab-promotion__image__pIUpU"};